export default {
	props: {

	},
	data() {
		return {

		}
	},
	created() {

	},
	methods: {
		wecomLogin() {
			let authCode = this.getRedirectUri(window.location.href, 'code')
			if (!authCode) {
				this.wecomLoginHref()
			} else {
				if (this.$store.state.system.systemdata) {
					this.$emit('login')
					return
				}
				this.$api.wecomlogin({
					authCode: authCode
				}).then((res) => {
					this.authlogin(res)
				}, () => {
					this.wecomLoginHref()
				})
			}
		},
		wecomLoginHref() {
			let redirect_uri = this.getRedirectUri(window.location.href, 'redirect_uri')
			redirect_uri = encodeURIComponent((redirect_uri ? redirect_uri : window.location.href) + '?logincompany=' +
				this.logincompany)
			window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + window.config.wecom
				.appid + '&redirect_uri='+redirect_uri+'&response_type=code&scope=snsapi_base&state=STATE&agentid=' + window
				.config.wecom.agentid + '#wechat_redirect'

		},
	},
}